import React, { useEffect, useState } from 'react';
import StaticHtmlContent from "../common/staticHtmlContent";
import { LinkText } from "../ecosystem/";
import LoginPageNotifier from "./LoginPageNotifier";

const AccountLockedNotifier = ({
    loginErrorCode,
    lockedUserError,
    userErrorMsg
}) => {

    return (
        (loginErrorCode === lockedUserError &&
            <LoginPageNotifier
                colorStyle="error"
            >
                    Your account has been locked. Please try again in 30 minutes 
                    or <LinkText
                        underline="always"
                        typographyType="body-02"
                        color="$color-primary-a2"
                        to={{ pathname: "/forgotusername" }}
                    >
                        reset your username
                    </LinkText> or <LinkText
                        underline="always"
                        typographyType="body-02"
                        aria-label="reset your password"
                        color="$color-primary-a2"
                        to={{ pathname: "/forgotpassword" }}
                    >
                        password
                </LinkText>.
            </LoginPageNotifier>
        )
    );
};

export default AccountLockedNotifier;
